<div class="container">
  <!-- loading bar -->
  <div *ngIf="dialogLoading" class="loadingMask">
    <p-progressSpinner></p-progressSpinner>
  </div>
<ng-container *ngIf="editPermision">
  <p-fileUpload
    #fileUpload
    [customUpload]="true"
    [mode]="'advanced'"
    (uploadHandler)="fileUploader($event)"
    chooseLabel="{{ 'ReceiptFormUpload.Select' | translate }}"
    uploadLabel="{{ 'ReceiptFormUpload.Upload' | translate }}"
    cancelLabel="{{ 'ReceiptFormUpload.Cancel' | translate }}"
  >
    <ng-template pTemplate="content" let-files>
      <div *ngIf="!files || !files.length" class="text-center">
        <p>
          <i class="pi pi-upload upload-icon"></i>
          {{ 'Common.PlaceHolder.FileDrag' | translate}}
        </p>
      </div>
    </ng-template>
  </p-fileUpload>
</ng-container>
  <br />
  <laas-data-table
    [defaultColumns]="docColumns"
    [value]="docs"
    [dataKey]="'sn'"
  >
    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <td *ngFor="let col of columns">
        <!-- default column -->
        <ng-container [ngSwitch]="col.field">
          <ng-container *ngSwitchCase="'downloadBtn'">
            <div class="text-center">
              <i class="pi pi-cloud-download" (click)="downloadDoc($event, rowData)"></i>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'deleteBtn'">
            <div class="text-center">
              <i class="pi pi-trash" (click)="deleteDoc($event, rowData)"></i>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'updateDt'">
            <div class="overflow-text">
              {{ rowData[col.field] | date: 'yyyy-MM-dd HH:mm' | replaceNullWith : "-" }}
            </div>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <div class="overflow-text">
              {{ rowData[col.field] | replaceNullWith : "-" }}
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
  </laas-data-table>
</div>
